import {
  type NotificationDto,
  NotificationStatus,
} from "Infrastructure/Api/Api";
import { useMemo } from "react";

const sortNotifications = (a: NotificationDto, b: NotificationDto) =>
  new Date(b.scheduledDate).getTime() - new Date(a.scheduledDate).getTime();

type GroupedNotifications = {
  plannedNotifications: Array<NotificationDto>;
  dispatchedNotifications: Array<NotificationDto>;
  deletedNotifications: Array<NotificationDto>;
};

export const useGroupNotifications = (
  notifications: Array<NotificationDto>,
): GroupedNotifications =>
  useMemo(() => {
    const sorted = [...notifications].sort(sortNotifications);
    const planned: Array<NotificationDto> = [];
    const dispatched: Array<NotificationDto> = [];
    const deleted: Array<NotificationDto> = [];

    for (const notification of sorted) {
      switch (notification.status) {
        case NotificationStatus.Planned:
          planned.push(notification);
          break;
        case NotificationStatus.Dispatched:
          dispatched.push(notification);
          break;
        case NotificationStatus.Deleted:
          deleted.push(notification);
          break;
      }
    }

    return {
      plannedNotifications: planned,
      dispatchedNotifications: dispatched,
      deletedNotifications: deleted,
    };
  }, [notifications]);
